import { motion } from "framer-motion";

const content = {
  privacidad: {
    overline: "Legal",
    title: "Política de Privacidad",
    body: [
      "En Medite Group tratamos tus datos personales con la máxima confidencialidad y de acuerdo con el Reglamento General de Protección de Datos (RGPD) y la normativa española vigente.",
      "Los datos que nos facilitas a través del formulario de contacto (empresa, nombre, email, teléfono, sector, número de empleados y el reto que nos describes) se utilizan únicamente para atender tu solicitud y ponernos en contacto contigo.",
      "No cedemos tus datos a terceros y los conservamos solo durante el tiempo necesario para gestionar tu consulta. Puedes ejercer tus derechos de acceso, rectificación, supresión y oposición escribiéndonos a info@meditegroup.com.",
    ],
  },
  "aviso-legal": {
    overline: "Legal",
    title: "Aviso Legal",
    body: [
      "Este sitio web es titularidad de Medite Group, con domicilio en Barcelona (08019), España, y correo electrónico de contacto info@meditegroup.com.",
      "El acceso y uso de este sitio web implica la aceptación de las presentes condiciones. Todos los contenidos, textos y elementos gráficos son propiedad de Medite Group o de sus legítimos titulares.",
      "Medite Group no se hace responsable del uso indebido de los contenidos de este sitio web ni de las decisiones tomadas a partir de la información aquí publicada sin un asesoramiento profesional previo.",
    ],
  },
  cookies: {
    overline: "Legal",
    title: "Política de Cookies",
    body: [
      "Este sitio web utiliza únicamente las cookies técnicas necesarias para su correcto funcionamiento. No utilizamos cookies publicitarias ni de seguimiento con fines comerciales.",
      "Puedes configurar tu navegador para bloquear o eliminar las cookies en cualquier momento. Ten en cuenta que desactivar algunas cookies puede afectar al funcionamiento del sitio.",
      "Si tienes cualquier duda sobre nuestra política de cookies, puedes escribirnos a info@meditegroup.com.",
    ],
  },
};

export default function Legal({ variant }) {
  const data = content[variant] || content["aviso-legal"];
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid={`legal-${variant}`}>
      <section className="pt-40 md:pt-52 pb-24 md:pb-40">
        <div className="max-w-[860px] mx-auto px-6 md:px-12">
          <div className="text-xs uppercase tracking-[0.25em] text-[#0B1F3A]/60 mb-6">{data.overline}</div>
          <h1 className="text-4xl md:text-6xl font-serif text-[#0B1F3A] tracking-tight leading-[1.02]">{data.title}</h1>
          <div className="mt-12 space-y-6 text-lg text-gray-600 leading-relaxed">
            {data.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>
      </section>
    </motion.div>
  );
}
